<template>
  <div class="box">
    <div class="content">
      <h3>您当前的浏览器不支持真相搜索应用</h3>
      <p>请将您的浏览器升级至最新版本后重新访问（IE 浏览器需要升级到 IE9 及以上版本）。<br>谢谢。</p>
    </div>

  </div>
</template>
<script>
  export default {
    data () {
      return {
        status: false,
        query: {  }
      }
    },
    mounted () {
    },
    methods: {

    }
  }
</script>
<style>
  .clearfix:after{
    content:".";
    display:block;
    height:0;
    clear:both;
    visibility:hidden
  }
  .clearfix{
    *+height:1%;
  }
  body,html,h3,ul,li{
    margin:0;
    padding:0;
  }
  li{
    list-style: none;
  }
  .content{
    width: 640px;
    height: 400px;
    margin: 70px auto 0 auto;
    text-align: center;
    border: none;
  }
  .content > img{
    margin-top:40px;
  }
  .content > h3{
    margin-top:10px;
    color:#bb0f0f;
  }
  .content > p{
    margin-top:20px;
    color:#333;
  }
</style>



// WEBPACK FOOTER //
// NotSupport.vue?d161f96e